import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromOrganisationState from './organisation.state';

export const getOrganisationState = createFeatureSelector<fromOrganisationState.OrganisationState>(fromOrganisationState.featureKey);

/** Select Organisations */
export const selectOrganisations = createSelector(getOrganisationState, state => state.organisations);
